// src/App.jsx

import { useEffect } from "react";

import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

// ==============================
// ESTILOS GLOBAIS
// ==============================

import "./App.css";
import "./Styles/navbar.css";
import "./Styles/Footer.module.css";
import "./Styles/btnwhatsapp.css";

// ==============================
// COMPONENTES DE LAYOUT
// ==============================

import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/footer";
import BtnWhatsapp from "./components/layout/btnwhatsapp";

// ==============================
// COMPONENTES DE NAVEGAÇÃO
// ==============================

import RouteRestorer from "./components/RouteRestorer";

// ==============================
// PÁGINAS
// ==============================

import HomePage from "./pages/Home";
import ServicosPage from "./pages/Servicos";
import LinkTreePage from "./pages/LinkTree";

// ==============================
// CONFIGURAÇÕES DO SITE
// ==============================

const SITE_CONFIG = {
  nome: "Dra. Fabiana Catarino",

  contato: {
    phone: "5511921881464",
    email: "",
  },
};

// ==============================
// MONITOR DE NAVEGAÇÃO
// ==============================

/**
 * Salva automaticamente a rota atual no cookie.
 *
 * Isso permite registrar a última página
 * acessada pelo usuário.
 */
function NavigationTracker() {
  const location = useLocation();

  useEffect(() => {
    const currentRoute =
      location.pathname +
      location.search +
      location.hash;

    document.cookie =
      `lastRoute=${encodeURIComponent(currentRoute)}; ` +
      `path=/; ` +
      `max-age=86400; ` +
      `SameSite=Lax`;
  }, [
    location.pathname,
    location.search,
    location.hash,
  ]);

  return null;
}

// ==============================
// CONTEÚDO PRINCIPAL
// ==============================

function AppContent() {
  const { phone } = SITE_CONFIG.contato;

  // Inicializa animações AOS
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
      easing: "ease-in-out-quad",
    });

    AOS.refresh();
  }, []);

  return (
    <div className="app">

      {/* =====================================
          RESTAURA A ROTA APÓS O REDIRECIONAMENTO
          DO 404.HTML DO GITHUB PAGES
      ====================================== */}

      <RouteRestorer />

      {/* =====================================
          SALVA A ROTA ATUAL
      ====================================== */}

      <NavigationTracker />

      {/* =====================================
          NAVBAR
      ====================================== */}

      <Navbar phone={phone} />

      {/* =====================================
          CONTEÚDO DAS PÁGINAS
      ====================================== */}

      <main className="app-main">

        <Routes>

          {/* HOME */}

          <Route
            path="/"
            element={
              <HomePage phone={phone} />
            }
          />

          {/* SERVIÇOS */}

          <Route
            path="/servicos"
            element={
              <ServicosPage phone={phone} />
            }
          />

          {/* LINK BIO */}

          <Route
            path="/LinkBio"
            element={
              <LinkTreePage phone={phone} />
            }
          />

          {/* =====================================
              ROTA NÃO ENCONTRADA
          ====================================== */}

          <Route
            path="*"
            element={
              <Navigate
                to="/"
                replace
              />
            }
          />

        </Routes>

      </main>

      {/* =====================================
          FOOTER
      ====================================== */}

      <Footer />

      {/* =====================================
          BOTÃO WHATSAPP
      ====================================== */}

      <BtnWhatsapp phone={phone} />

    </div>
  );
}

// ==============================
// APP PRINCIPAL
// ==============================

export default function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

